import Section from "../components/Section";
import Seo from "../components/Seo";

export default function MentionsLegales() {
  return (
    <>
      <Seo path="/mentions-legales" title="Mentions légales" noindex />
      <Section eyebrow="Mentions légales" title="Mentions légales">
      <div className="prose-base max-w-3xl text-ink-soft leading-relaxed space-y-4">
        <p>Texte des mentions légales à intégrer en phase 5.</p>
      </div>
      </Section>
    </>
  );
}
